export const GET_LIST = 'bug/GET_LIST';
export const CHANGELIST = 'buy/CHANGELIST';
export const CHANGETIME = 'buy/CHANGETIME';
export const GET_APILIST = 'buy/GET_APILIST';